import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Crime, GovernyInfo, ThiefActionType } from "../../../../lib/types";

import { cancelThieves, sendThieves } from "../../../../store/actions";
import { DragescentState } from "../../../../store/reducers/stateType";
import GovernoratePivotColumn from "../../../Common/GovernoratePivotColumn";
import HelpIcon from "../../../Common/HelpIcon";

interface IProps {
  sender: number;
  gold: number;
  disabled: boolean;
  target: GovernyInfo;
  counterintelligence?: Crime;
  counterintelligenceType: ThiefActionType;
}

const Counterintelligence = ({
  sender,
  gold,
  disabled,
  target,
  counterintelligence,
  counterintelligenceType
}: IProps) => {
  const id = useSelector((state: DragescentState) => state.governorate.id);
  const dispatch = useDispatch();

  return (
    <tr>
      <GovernoratePivotColumn
        id={target.id}
        name={target.name}
        race={target.race.name}
        commander={target.commander}
        emperor={target.emperor}
      />
      <td>
        {
          counterintelligence
            ? <>
              {counterintelligenceType.name}&nbsp;
              <HelpIcon
                title={counterintelligenceType.name}
                content={counterintelligenceType.description}
                iconClasses={["white", "align-sub"]}
              />&nbsp;
              &nbsp;<a
              className="link"
              onClick={() => dispatch(cancelThieves(
                8,
                target.id,
                sender,
                sender === id
              ))}
            >
              cancel
            </a>
            </>
            : <a
              className={`btn btn-black btn-no-width ${gold < 100 || disabled ? "disabled" : ""}`}
              onClick={() => gold < 100 || disabled
                || dispatch(sendThieves(8, target.id, 0, sender, sender === id))}
            >
              Send {counterintelligenceType.gold} <i className="icon icon-sm icon-zlato gold"/>
            </a>
        }
      </td>
    </tr>
  )
}

export default Counterintelligence;
